// Shipping Protection 开关（购物车抽屉，默认关闭）：顾客打开才加 $3.95 运费险，关掉就移除；
// 购物车里只剩运费险时自动移除它。开关由 cart-drawer 的 custom_liquid 块渲染（#rl-sp-toggle）。
(function () {
  var VID = 48242683936966;

  function cart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  }
  function refreshDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return Promise.resolve();
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var fresh = new DOMParser().parseFromString(s['cart-drawer'] || '', 'text/html').querySelector('cart-drawer');
        if (!fresh) return;
        var cur = drawer.querySelector('.drawer__inner'), nxt = fresh.querySelector('.drawer__inner');
        if (cur && nxt) cur.innerHTML = nxt.innerHTML;
        drawer.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && s['cart-icon-bubble']) {
          var b = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (b) bubble.innerHTML = b.innerHTML;
        }
      });
  }

  // 顾客点开关
  document.addEventListener('change', function (e) {
    if (!e.target || e.target.id !== 'rl-sp-toggle') return;
    var on = e.target.checked;
    e.target.disabled = true;
    cart().then(function (c) {
      var prot = c.items.filter(function (i) { return i.variant_id === VID; });
      if (on && !prot.length) return post('/cart/add.js', { items: [{ id: VID, quantity: 1 }] });
      if (!on && prot.length) return post('/cart/change.js', { id: prot[0].key, quantity: 0 });
    }).then(refreshDrawer).catch(function () {});
  });

  // 顾客删掉所有商品后，顺手把孤零零的运费险也删掉（只删不加）
  function cleanup() {
    cart().then(function (c) {
      var prot = c.items.filter(function (i) { return i.variant_id === VID; });
      var real = c.items.filter(function (i) { return i.variant_id !== VID; });
      if (!real.length && prot.length) return post('/cart/change.js', { id: prot[0].key, quantity: 0 }).then(refreshDrawer);
    }).catch(function () {});
  }
  var t = null;
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('cart-remove-button, .cart-remove-button, [name="minus"]')) { clearTimeout(t); t = setTimeout(cleanup, 1200); }
  });
})();
